import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** 上传短剧代码加载时按默认已有数据源配置占位，不挂载表单、文件选择或上传请求 */
export function UploadVideoSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
      <Card>
        <CardContent className="space-y-6 pt-6">
          <div className="space-y-6">
            {/** 上传配置、模板入口和默认已有数据源选择 */}
            <div className="space-y-6">
              <Skeleton className="h-7 w-20" />
              <Skeleton className="h-5 w-72 max-w-full" />
              <div className="space-y-3">
                <Skeleton className="h-3.5 w-24" />
                <div className="flex items-center gap-6">
                  {Array.from({ length: 2 }, (_, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <Skeleton className="h-4 w-4 rounded-full" />
                      <Skeleton className="h-3.5 w-28" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="space-y-2">
                <Skeleton className="h-9 w-full md:w-[400px]" />
              </div>
              {/** 全量更新和增量更新 */}
              <div className="space-y-3">
                <Skeleton className="h-3.5 w-14" />
                <div className="flex items-center gap-6">
                  {Array.from({ length: 2 }, (_, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <Skeleton className="h-4 w-4 rounded-full" />
                      <Skeleton className="h-3.5 w-14" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/** 文件拖拽区沿用原图标、提示和内边距，首次不展示上传进度 */}
            <div className="space-y-4">
              <Skeleton className="h-7 w-20" />
              <div className="space-y-2">
                <div className="border-2 border-dashed rounded-lg p-12 text-center border-gray-300">
                  <div className="flex flex-col items-center gap-2">
                    <Skeleton className="h-16 w-16 rounded-full" />
                    <div className="space-y-1">
                      <Skeleton className="h-5 w-64 max-w-full" />
                      <Skeleton className="h-4 w-52 max-w-full mx-auto" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/** 取消和确定入口 */}
            <div className="flex justify-end gap-4 pt-4 border-t">
              <Skeleton className="h-9 w-16" />
              <Skeleton className="h-9 w-16" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
